export default __webpack_public_path__ + "static/media/league_icon.d9e06d6d.png";